import superagent from 'superagent';
import { apiFilter } from 'next-common-lib';

function noCache(request) {
  request.set('Cache-Control', 'no-cache');
  request.set('Pragma', 'no-cache');
  return request;
}

const agent = navigator.userAgent.toLowerCase();
let isIE = false;
if ((navigator.appName === 'Netscape' && agent.indexOf('trident') !== -1) || agent.indexOf('msie') !== -1) {
  isIE = true;
}

const finalNoCache = isIE ? noCache : () => {};
const jsonp = require('jsonp');

const callJsonp = url =>
  new Promise((resolve, reject) => {
    jsonp(url, null, function (err, data) {
      if (err) {
        reject(err.message);
      } else {
        resolve(data);
      }
    });
  });

const responseBody = res => {
  if (res.body !== null) return res.body;
  return res;
};

const responseBodyJsonp = res => {
  if (res !== null) return res.data.result;
  return res;
};

// API 호출 error
const errorCatchCallback = err => {
  if (err.errno === 'ETIMEDOUT') {
    const returnResponse = {
      ...err,
      errorCode: 'MB_M_PERSONALINFO_ERR_TIMEOUT',
    };
    throw returnResponse;
  } else if (err.crossDomain) {
    const returnResponse = {
      ...err,
      errorCode: 'crossDomain',
    };
    throw returnResponse;
  } else if (err.response && err.response.status !== 200) {
    const _apiFilter = apiFilter(err, { Module: 'EM' });
    if (!_apiFilter?.passFilter) {
      // console.log('403');
    } else {
      throw err.response && err.response.body;
    }
  } else {
    throw err.response && err.response.body;
  }
};
const retryCount = 0;

const urlToSSL = url => {
  const port = 443;
  return `https://${window.location.hostname}:${port}${url}`;
};

const requests = {
  del: url =>
    superagent
      .del(url)
      .withCredentials()
      .timeout({ response: 10000, deadline: 60000 })
      .retry(retryCount)
      .then(responseBody)
      .catch(err => errorCatchCallback(err, url)),
  get: (url, responseTimeout) =>
    superagent
      .get(url)
      .withCredentials()
      .set('Content-type', 'application/json')
      .use(finalNoCache)
      .timeout({
        response: responseTimeout !== undefined ? responseTimeout : 10000,
        deadline: 60000,
      })
      .retry(retryCount)
      .then(responseBody)
      .catch(err => errorCatchCallback(err, url)),
  put: (url, body) =>
    superagent
      .put(url, body)
      .withCredentials()
      .timeout({ response: 10000, deadline: 60000 })
      .retry(retryCount)
      .then(responseBody)
      .catch(err => errorCatchCallback(err, url)),
  post: (url, body) =>
    superagent
      .post(url, body)
      .withCredentials()
      .timeout({ response: 10000, deadline: 60000 })
      .retry(retryCount)
      .then(responseBody)
      .catch(err => errorCatchCallback(err, url)),
  postHTTPS: (url, body, utoken, json) =>
    superagent
      .post(urlToSSL(url), body)
      .set('Content-Type', json || 'application/x-www-form-urlencoded')
      .set('Accept', 'application/json')
      .withCredentials()
      .set('Authorization', utoken || '')
      .timeout({ response: 10000, deadline: 60000 })
      .retry(retryCount)
      .then(responseBody)
      .catch(err => errorCatchCallback(err, url)),
  attach: (url, formData) => superagent.post(url, formData),
  getJSONP: url =>
    callJsonp(url)
      .then(responseBodyJsonp)
      .catch(err => errorCatchCallback(err, url)),
  getHtml: url =>
    superagent
      .get(url)
      .withCredentials()
      .retry(retryCount)
      .then(res => res.text)
      .catch(err => errorCatchCallback(err, url)),
};
export default requests;
